export const openInNewTab = (url: string | null | undefined): boolean => {
  const trimmed = url?.trim() ?? "";
  if (!trimmed) {
    return false;
  }
  window.open(trimmed, "_blank", "noopener,noreferrer");
  return true;
};
